import React, { useState, useRef, useEffect } from "react";

import Icon from "../media/icon/icons";
import Landingline from "../media/image/landing-lines.png";
import Logo from "../media/image/axipays-full-white-logo.jpg";
import Topcards from "../media/image/topcards.png";
import visa from "../media/image/visa.webp";
import mastercard from "../media/image/mastercard.webp";
import discover from "../media/image/discover.webp";
import unionpay from "../media/image/unionpay.webp";
import jcb from "../media/image/jcb.webp";

import Footer from "./website/Footer";
// import gradientline from "../media/image/gradientline.png";

const faqs = [
    {
        question: "Who is eligible to join the Axipays' Referral Programme?",
        answer:
            "Any individual or business interested in earning passive income through Axipays' Referral Program.",
    },
    { question: "How can I refer a business?", answer: "Simply reach out to your Axipays representative and facilitate the introduction." },
    { question: "Is there a limit to the number of businesses I can refer?", answer: "No, you can refer as many businesses as you want." },
    { question: "Is it necessary to be a Axipays client to join the referral program?", answer: "No, you can participate even if you are not a Axipays customer." },
    { question: "How can I monitor my referral earnings?", answer: "You can track your earnings through detailed reports that offer clear insights into your referral income and commissions." },
];

const Referral = () => {
    const [isOpen, setIsOpen] = useState(false);
    const [openIndex, setOpenIndex] = useState(null);
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [telegram, setTelegram] = useState("");
    const [whatsapp, setWhatsapp] = useState("");
    const [highrisk, setHighrisk] = useState(false);
    const [midrisk, setMidrisk] = useState(false);
    const [lowrisk, setLowrisk] = useState(false);

    const [volume, setVolume] = useState("");
    const [message, setMessage] = useState("");
    const [messageColor, setMessageColor] = useState("");
    const answerRefs = useRef([]);

    useEffect(() => {
        answerRefs.current.forEach((el, index) => {
            if (el) {
                el.style.height = openIndex === index ? `${el.scrollHeight}px` : '0px';
            }
        });
    }, [openIndex]);

    const toggleFAQ = (index) => {
        setOpenIndex((prevIndex) => (prevIndex === index ? null : index));
    };

    const toggleForm = () => {
        setIsOpen(!isOpen);
        clearForm();
    };

    const handleRegister = async (e) => {
        e.preventDefault();

        const requestBody = {
            full_name: name,
            email: email,
            telegram_id: telegram,
            whatsapp_no: whatsapp,
            highrisk: highrisk,
            midrisk: midrisk,
            lowrisk: lowrisk,
            volume: volume
        };

        try {
            const response = await fetch("https://api.axipays.com/api/v1/website/referral", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(requestBody),
            });

            if (response.ok) {
                setMessage("Subscription Successful!");
                setMessageColor("green");
                clearForm();
            } else {
                setMessage("Failed to subscribe!");
                setMessageColor("red");
            }

            setTimeout(() => {
                setMessage("");
            }, 3000);

        } catch (error) {
            setMessage("Something went wrong. Please try again later.");
            setMessageColor("red");

            setTimeout(() => {
                setMessage("");
            }, 3000);
        }
    };

    const clearForm = () => {
        setName("");
        setEmail("");
        setTelegram("");
        setHighrisk("");
        setMidrisk("");
        setLowrisk("");
        setVolume("");
        setWhatsapp("");
    };

    window.addEventListener('scroll', function () {
        const elementIds = ['animateOnScroll', 'animateOnScrolled', 'animateOnScrolledfaq'];

        elementIds.forEach((id) => {
            const element = document.getElementById(id);
            if (element && !element.classList.contains('animated')) {
                const position = element.getBoundingClientRect();

                if (position.top < window.innerHeight && position.bottom >= 0) {
                    element.classList.add('show', 'animated');
                }
            }
        });
    });

    window.addEventListener('scroll', function () {
        const banner = document.querySelector('.cta-banner');
        if (banner) {
            const position = banner.getBoundingClientRect();
            const halfHeight = position.height / 2;

            if (position.top < window.innerHeight - halfHeight && position.bottom > halfHeight) {
                banner.classList.add('visible');
            }
        }
    });

    window.addEventListener('scroll', function () {
        const referralSteps = document.querySelector('.referral-steps');
        if (referralSteps) {
            const position = referralSteps.getBoundingClientRect();
            if (position.top < window.innerHeight && position.bottom >= 0) {
                referralSteps.classList.add('show');
            }
        }
    });

    const handleGoBack = () => {
        window.history.back();
    };

    return (
        <section id="referral">
            <div className="top">
                <div className="rf-header">
                    <div className="header-top">
                        <div className="axi-logo"><img src={Logo} alt="logo" /></div>
                        <button className="rf-contact-btn" onClick={handleGoBack}>Contact Now</button>
                    </div>
                    <div className="top-cards">
                        <img src={Topcards} alt="" />
                        <h4>Your Global Payment Processor</h4>
                    </div>

                </div>
                <div className="rf-main">
                    <h1>Turn Connections into Commissions <br />with Axipays Referral Programme</h1>
                    <button className="common-btn regis-btn" onClick={toggleForm}>
                        <span>Register Now</span>
                    </button>
                    <img src={Landingline} alt="" className="landingline" />
                </div>
            </div>
            <div className={`form-overlay ${isOpen ? "blur" : ""}`}></div>
            <div className={`form-wrapper ${isOpen ? 'open' : ''}`}>
                <div className="form-wrapper-form">
                    <button className="close-btn" onClick={toggleForm}>&times;</button>
                    <h2>Axipays Referral Program</h2>
                    <p>Fill the details given below!</p>
                    {message && (
                        <div className={`message-box ${messageColor}`}>
                            {message}
                        </div>
                    )}

                    <input
                        type="text"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        placeholder="Full Name"
                    />

                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder="Email ID"
                    />

                    <input
                        type="text"
                        value={telegram}
                        onChange={(e) => setTelegram(e.target.value)}
                        placeholder="Telegram"
                    />

                    <input
                        type="text"
                        value={whatsapp}
                        onChange={(e) => setWhatsapp(e.target.value)}
                        placeholder="WhatsApp Number"
                    />

                    <div className="checkbox-group">
                        <label className="checkbox-label-title">Industry:</label>
                        <div className="flex-check">
                            <label className="custom-checkbox">
                                <input
                                    type="checkbox"
                                    checked={highrisk}
                                    onChange={() => setHighrisk(!highrisk)}
                                />
                                <span className="checkmark"></span>
                                <span className="checkbox-text">High Risk</span>
                            </label>

                            <label className="custom-checkbox">
                                <input
                                    type="checkbox"
                                    checked={midrisk}
                                    onChange={() => setMidrisk(!midrisk)}
                                />
                                <span className="checkmark"></span>
                                <span className="checkbox-text">Medium Risk</span>
                            </label>

                            <label className="custom-checkbox">
                                <input
                                    type="checkbox"
                                    checked={lowrisk}
                                    onChange={() => setLowrisk(!lowrisk)}
                                />
                                <span className="checkmark"></span>
                                <span className="checkbox-text">Low Risk</span>
                            </label>
                        </div>
                    </div>


                    <input
                        type="text"
                        value={volume}
                        onChange={(e) => setVolume(e.target.value)}
                        placeholder="Volume (e.g. $10,000/month)"
                    />

                    <button className="send-btn" onClick={handleRegister}>Send Invite</button>

                </div>
                <div className="layered-effect">
                    <div className="layer">
                    </div>
                </div>
            </div>

            <div className="rf-service">
                <div className="rf-container">
                    <div className="rf-service-header">
                        <h1 className="rf-title" id="animateOnScroll">Maximize Your Rewards with <br />Axipays' Exclusive Referral Program!</h1>
                        <p className="subtitle">Unlock Rewards with Every Connection</p>
                    </div>

                    <div className="points-section">
                        {["Refer Globally", "Timely Payouts", "Scale with Us"].map((item, index) => {

                            const descriptions = [
                                "Invite businesses globally & earn unlimited rewards!",
                                "Get your payouts on time with Axipays.",
                                "Partner with us and grow your network!"
                            ];

                            return (
                                <div key={index} className={`point-card ${index < 2 ? "border-right" : ""}`}>
                                    <div className="point-icon">
                                        <Icon name="rficon" width={40} height={40} />
                                        <h3 className="point-title">{item}</h3>
                                    </div>
                                    <p className="point-description">{descriptions[index]}</p>
                                </div>
                            );
                        })}
                    </div>

                    <div className="cta-banner">
                        <h2 className="cta-title">Turn Your Network Into Passive Income</h2>
                        <p className="cta-description">Earn recurring commissions every month when businesses you refer process payments with Axipays - simple, transparent, and built for growth.</p>
                        <button className="common-btn cta-button" onClick={toggleForm}><span>Register Now</span></button>
                    </div>
                    {/* <img src={gradientline} alt="gradientline" className="gradientline" /> */}
                </div>
            </div>

            <div className="rf-feature">
                <div className="rectngleright"></div>
                <div className="rectngleleft"></div>
                <div className="rf-feature-container">
                    <div className="left-section">
                        <h1 id="animateOnScrolled" className="rf-feature-anime">HOW IT WORKS!</h1>
                        <p className="subline">Join us in revolutionizing the payment landscape with our newly launched Referral Programme.</p>
                    </div>
                    <div className="right-section">
                        {["Refer Merchants", "Earn Commissions", "Leverage Competitive MDR Rates", "Timely Benefits", "Referral Chain Model"].map((title, index) => (
                            <div className="step" key={index}>
                                <span>
                                    <h1>{`0${index + 1}.`}</h1>
                                    <h2>{title}</h2>
                                </span>
                                <p>
                                    {index === 0 && "Connect businesses with Axipays and introduce them to our tailored solutions."}
                                    {index === 1 && "Benefit from flexible commission options, including Markup or Revenue Share."}
                                    {index === 2 && (
                                        <>Visa/Mastercard solutions starting at just <p className="highlight">3.5%</p> MDR.</>
                                    )}
                                    {index === 3 && "Enjoy on-time reports, transparent communication, and guaranteed payouts."}
                                    {index === 4 && "Refer other partners and earn commissions as your network grows."}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <div className="faq-container">
                <h2 id="animateOnScrolledfaq" className="faq-title">Frequently Asked <span>Questions</span></h2>
                <div className="faq-inner-container">
                    <div className="faq-list">
                        {faqs.map((faq, index) => (
                            <div
                                key={index}
                                className={`faq-item ${openIndex === index ? 'open' : ''}`}
                                onClick={() => toggleFAQ(index)}
                            >
                                <div className="faq-question">
                                    {faq.question}
                                    <span className="faq-icon">{openIndex === index ? '-' : '+'}</span>
                                </div>
                                <div
                                    className="faq-answer-wrapper"
                                    ref={(el) => (answerRefs.current[index] = el)}
                                >
                                    <div className="faq-answer">{faq.answer}</div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>


            <div className="rf-pay">
                <div className="rectngleright"></div>
                <div className="rectngleleft rectleftbg"></div>
                <div className="rf-pay-container">
                    <button className="referral-btn">Axipays Referral Program</button>
                    <div className="referral-steps">
                        <span className="rf-step"><Icon name="accountwallet"></Icon>Refer.</span>
                        <span className="arrow">→</span>
                        <span className="rf-step"><Icon name="articleshortcut"></Icon>Earn.</span>
                        <span className="arrow">→</span>
                        <span className="rf-step"><Icon name="restartalt"></Icon>Repeat.</span>
                    </div>
                    {/* <div className="referral-network">
                        <div className="referral-card">
                            <img src={pay1} alt="User" />
                            <div>
                                <p>Allen Fores<br />
                                    <span className="gry-p">Chife technology officer</span></p>
                            </div>
                        </div>
                        <div className="referral-grid">
                            {[...Array(3)].map((_, index) => (
                                <div key={index} className="referral-card">
                                    <img src={pay2} alt="User" />
                                    <div>
                                        <p>Allen Fores<br />
                                            <span className="gry-p">Chife technology officer</span></p>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className="referral-grid">
                            {[...Array(2)].map((_, index) => (
                                <div key={index} className="referral-card">
                                    <img src={pay3} alt="User" />
                                    <div>
                                        <p>Allen Fores
                                            <br />
                                            <span className="gry-p">Chife technology officer</span>
                                        </p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div> */}
                    <h2 className="rf-heading">Earn Rewards for Every Successful Referral!</h2>
                    <p className="subtext">
                        Monetize your network by referring businesses to Axipays. Earn rewards for every successful introduction and enjoy a steady stream of passive income. Whether you're an individual or a business, our referral program makes it easy to generate consistent financial benefits. Start referring today and watch your connections turn into valuable rewards!
                    </p>
                    <button className="common-btn register-btn" onClick={toggleForm}><span>Register Now</span></button>
                    <div className="payment-logos">
                        <img src={visa} alt="Visa" />
                        <img src={mastercard} alt="MasterCard" />
                        <img src={jcb} alt="Discover" />
                        <img src={discover} alt="UnionPay" />
                        <img src={unionpay} alt="SSL Secure" />
                    </div>
                </div>
            </div>

            <Footer hideFooterTop={true} />
        </section>
    );
};

export default Referral;
